/**
 * ProgressRing — SVG donut with a percent label in the center.
 * Amber stroke on neutral track. Animates draw-in on mount.
 */
import React from 'react';

export const ProgressRing = ({
  value = 0,       // 0..100
  size = 44,
  stroke = 4,
  showLabel = true,
  testId = 'progress-ring',
}) => {
  const pct = Math.max(0, Math.min(100, Number(value) || 0));
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const dash = (pct / 100) * c;
  return (
    <div className="inline-flex items-center justify-center relative" style={{ width: size, height: size }} data-testid={testId}>
      <svg width={size} height={size} className="-rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke="hsl(var(--border))"
          strokeWidth={stroke}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke="hsl(var(--primary))"
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={`${dash} ${c}`}
          style={{ transition: 'stroke-dasharray 700ms cubic-bezier(0.2,0.65,0.25,1)' }}
        />
      </svg>
      {showLabel && (
        <span className="absolute inset-0 flex items-center justify-center text-[10px] font-extrabold text-foreground">
          {Math.round(pct)}%
        </span>
      )}
    </div>
  );
};

export default ProgressRing;
